export const WORKSPACE_INVITE_NOTIFICATION_PREFIX = 'workspace-invite-';
export const MESSENGER_ROOM_INVITE_NOTIFICATION_PREFIX = 'messenger-room-invite-';
export const MEETING_SPACE_INVITE_NOTIFICATION_PREFIX = 'meeting-space-invite-';

export const getWorkspaceInviteNotificationId = (roomId: string): string =>
  `${WORKSPACE_INVITE_NOTIFICATION_PREFIX}${roomId}`;

export const getMessengerRoomInviteNotificationId = (roomId: string): string =>
  `${MESSENGER_ROOM_INVITE_NOTIFICATION_PREFIX}${roomId}`;

export const getMeetingSpaceInviteNotificationId = (roomId: string): string =>
  `${MEETING_SPACE_INVITE_NOTIFICATION_PREFIX}${roomId}`;

export const isInviteNotificationToastId = (id: string): boolean =>
  id.startsWith(WORKSPACE_INVITE_NOTIFICATION_PREFIX) ||
  id.startsWith(MESSENGER_ROOM_INVITE_NOTIFICATION_PREFIX) ||
  id.startsWith(MEETING_SPACE_INVITE_NOTIFICATION_PREFIX);
